import CloseIcon from '@mui/icons-material/Close';
import { Box, Dialog, DialogContent, IconButton, useMediaQuery } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { config } from '../utils/config';
import getUser from '../utils/getUser';
import { theme } from '../utils/theme';

export interface IPlateModalProps {
  id: number,
  open: boolean,
  onClose: () => void,
  board: string
}

export const PlateModal: React.FC<IPlateModalProps> = ({
  id,
  open,
  onClose,
  board
}) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const user = getUser();
  if ((!id && open) || (!user?.access_token && open)) {
    return <CircularProgress />;
  }
  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{ width: '100%', height: isMobile ? '100%' : '80%' }}
      PaperProps={{ sx: { height: isMobile ? 'auto' : '600px', width: '100%', m: 1, maxWidth: '1000px' } }}
    >
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 0,
          color: (theme) => theme.palette.grey[900],
          zIndex: 1000
        }}
        data-automation="plate-exit"
      >
        <CloseIcon />
      </IconButton>
      <DialogContent sx={{ pl: isMobile ? 0 : 1, pr: isMobile ? 0 : 1 }} data-automation="plate-modal">
        <Box sx={{ display: isMobile ? 'block' : 'flex', width: '100%', height: isMobile ? 'auto' : 'calc(100% - 16px)', mt: 2 }}>
          <iframe
            title="HTML Content"
            data-automation="plate-detail"
            src={`${config.apiUrl}/legacy-plate-detail/${id}/${board}?j=${user?.access_token}`}
            style={{ width: isMobile ? '100%' : '60%', height: isMobile ? '370px' : '100%', border: 0, boxShadow: 'none', position: 'relative', minWidth: isMobile ? 'none' : '380px' }}
          />
          <iframe
            title="HTML Content"
            data-automation="plate-legend"
            src={`${config.apiUrl}/legacy-plate-legend/${id}/${board}?j=${user?.access_token}`}
            style={{ width: isMobile ? '100%' : '40%', height: isMobile ? '340px' : '100%', border: 0, boxShadow: 'none', position: 'relative', top: isMobile ? '-7px' : 0, overflow: 'hidden' }}
          />
        </Box>
      </DialogContent>
    </Dialog>
  )
}